import { useQuery } from '@tanstack/react-query'

import { useSelectedProjectStore } from '@/components/entities/common/model/selected-project.store'

import { UsersService } from '../lib/users.service'

const PROJECT_FEATURES_QUERY_KEY = 'PROJECT_FEATURES_QUERY_KEY'

const useProjectFeatures = () => {
  const { selectedProjectId: projectId } = useSelectedProjectStore()

  const { data, isLoading, isError, error } = useQuery({
    queryKey: [PROJECT_FEATURES_QUERY_KEY, projectId],
    queryFn: () => UsersService.getProjectFeatures(projectId),
    enabled: Boolean(projectId)
  })

  return { data, isLoading, isError, error }
}

export { useProjectFeatures }
